<template>
    <div>
        <card-header title="Edit Discount Code" icon="fa-pencil" />

        <card-body>
            <card-list>
                <container-list-item>
                    <data-row title="Is Used">
                        <span class="stat" v-if="discount.is_single_use && discount.is_used"><i class="far fa-check"></i></span>
                        <span class="stat" v-else><i class="far fa-ban"></i></span>
                    </data-row>
                    <data-row title="Use Count">{{ discount.use_count }}</data-row>
                    <data-row title="Last Used"><span v-if="discount.last_used_at">{{ discount.last_used_at | moment('MMMM Do YYYY, h:mm:ss a') }}</span><span v-else>Unused</span></data-row>
                </container-list-item>
            </card-list>
            <conf-discount-form :discount="discount" />
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <!-- <b-button type="is-warning is-outlined" size="is-small" @click=""><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Discount?</span></b-button>-->
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!discount.title || !discount.code || !discount.type || !discount.value"
                    ><i class="fas fa-check mr-2"></i>Save Discount
                    </b-button>
                </div>
            </div>
        </card-footer>


    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import {client as http} from '@/http_client';
    import ConfDiscountForm from "./DiscountForm";
    import moment from "moment/moment";


    export default {
        components: {DataRow, ContainerListItem, CardList, ConfDiscountForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                discount: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            load: function () {
                console.log('loading')
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId + '/discounts/' + this.props.discountId, {force: true}).then(response => {
                    response.data.value = response.data.value.toString();
                    this.discount = response.data;
                    this.discount.expires_at = (response.data.expires_at) ? moment(response.data.expires_at).toDate() : null;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function () {
                http.put('conferences/' + this.props.confId + '/discounts/' + this.props.discountId, {
                    id: this.discount.id,
                    title: this.discount.title,
                    code: this.discount.code,
                    type: this.discount.type,
                    value: this.discount.value,
                    applies_to: this.discount.applies_to,
                    expires_at: this.discount.expires_at,
                    is_single_use: this.discount.is_single_use
                }, {force: true}).then(response => {
                    this.$reloadCard('conf-discounts');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the discount.');
                    this.$emit('loading', false);
                });
            }
        },
        watch: {
            'props.discountId': function () {
                this.dirty = null;
                this.load();
            },
            'discount': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this discount? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
